import { render, staticRenderFns } from "./DataTableRowLayout.vue?vue&type=template&id=9b24a7c0&scoped=true&"
import script from "./DataTableRowLayout.vue?vue&type=script&lang=js&"
export * from "./DataTableRowLayout.vue?vue&type=script&lang=js&"
import style0 from "./DataTableRowLayout.vue?vue&type=style&index=0&id=9b24a7c0&scoped=true&lang=css&"
import style1 from "../../assets/style/base.css?vue&type=style&index=1&id=9b24a7c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b24a7c0",
  null
  
)

export default component.exports